import Nullstack from 'nullstack';
export default function IconViewportWide({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-viewport-wide",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 12h-7l3 -3m0 6l-3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M14 12h7l-3 -3m0 6l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M3 6v-3h18v3"
  }), "   ", Nullstack.element("path", {
    d: "M3 18v3h18v-3"
  }), " ");
}